import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MicrowaveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"microwave"}/>
}
